import $, {  } from 'jquery';
import { makeStore } from "../../support/pile";
import { access, isArray, isNumber, isString, isUndef } from "../../support/general";
import { sendCommand } from '../../support/LocalCommand';
import { blockToBlockData } from './changes_admin';
import { documentTypes } from '../ux/subscriptTypes';

export var selectionStore = makeStore({
    model : {
        selectedBlockId : 0
    } 
})

export function makeUniversalBlockKey(scriptId,blockId){
    return scriptId+"_"+blockId;
}

export var modelObjectAdapters = {

}

export function getModelObject(path){
    return access(modelStore.state.model,path);
}

export function cloneBlock(block){
    return $.extend(true,{},block);
}

export function cloneArrayOfBlocks(blocks){
    return blocks.map(block=>cloneBlock(block));
}

function getPage( subscript , at ) {
    var pageIndex = 0;
    var page = subscript.pages[pageIndex];
    var offset = at;
    
    do {
        if (offset>=page.length){
            
            if (pageIndex<subscript.pages.length-1){
                offset-=page.length;
                pageIndex++
                page = subscript.pages[pageIndex];
            } else {
                break;
            }
        }
    } while(offset >= (page.length))

    return {
        pages:subscript.pages,
        page,
        pageIndex,
        offset
    }
}

function insertIntoPages(subscript,blockId,at) {
    const {pages,page,pageIndex,offset} = getPage(subscript,at);

    if (offset<page.length){
        page.splice(offset,0,blockId);
    }else {
        page.push(blockId);
    }
    subscript.pages[pageIndex] = subscript.pages[pageIndex].slice(0); 
    if (page.length<5 || page.length>100){
        redoSubscriptPages(subscript);
    }
}

function deleteFromPages(subscript,at){
    const {pages,page,pageIndex,offset} = getPage(subscript,at);
    page.splice(offset,1);
    subscript.pages[pageIndex] = page.slice(0); 
    if ( page.length ==0  || page.length>100){
        redoSubscriptPages(subscript);
    }
}

function checkBlockIdCaches(subscript){
    
    var blockIds = {};
    $.each(subscript.orderedIds,(b,blockId)=>{
        if (blockIds[blockId]){
            throw "Duplicate Block Id in subscript.orderedId : "+blockId
        }
        blockIds[blockId] = true;
    });

    $.each(subscript.pages,(p,page)=>{
        var pageBlockIds = {}
         $.each(page,(b,blockId)=>{
            if (!blockIds[blockId]){
                throw "block Id found in pages that is not in subscript.orderedId : "+blockId
            }
            delete blockIds[blockId];
            if (pageBlockIds[blockId]){
                throw "Duplicate Block Id in page : "+ blockId
            }
            pageBlockIds[blockId] = true;

         });
    });

    $.each(blockIds,(b,blockId)=>{
         throw "Block missing from pages : "+ blockId
    })

}
function redoSubscriptPages (subscript){

    var page = [];
    var pages = [page];
    $.each(subscript.orderedIds,(at,blockId)=>{
        page.push(blockId);
        if (page.length>50){
            page = [];
            pages.push(page);
        }
    });
    subscript.pages = pages;

}

export function getBlock(scriptId,blockId){
    return access(modelStore.state,["model","Block",makeUniversalBlockKey(scriptId,blockId)]);
}
export function getBlockRange(scriptId,subscriptId,fromPosition,number){
    var blocks = [];
    var subscript = access(modelStore,["state","model","Script",scriptId,"subscripts",subscriptId]);
    if (subscript){
        for ( var v=0 ; v<number ; v++ ) {
            var blockId = subscript.orderedIds[fromPosition+v];
            var block = modelStore.state.model.Block[makeUniversalBlockKey(scriptId,blockId)];
            blocks.push(block);
        }
    }
    return blocks;
}

var nextSingleShotCaretClass = 1;
export var modelStore = makeStore({
    
    model : {
        Block: {}, // indexed by local id - localBlockId is set when added
        Script :{}, // indexed by script id
        showNavigation : false,
        showFolder : true,
        loadedScriptId : 1,
        focussedSubscriptId : 0,
    },

    isSending : false,

    access : function (path,defaultValue){
        return access(this,path,defaultValue);
    },

    getFocussedSubscript : function (){
        return access(this,["model","Script",this.model.loadedScriptId,"subscripts",this.model.focussedSubscriptId]);
    },

    getFocussedSubscriptTypeHandler : function (){
        return documentTypes[this.getFocussedSubscript()?.type];
    },
    
    getBlockLocation : function (scriptId,subscriptId,blockIdentifier){
        var orderedIds = access(this.model,["Script",scriptId,"subscripts",subscriptId,"orderedIds"]);
        if (orderedIds){
            var blockId = isString(blockIdentifier)?parseInt(blockIdentifier.split("_")[1]):blockIdentifier;
            for (var at=0;at<orderedIds.length;at++){
                if (orderedIds[at] == blockId){
                    return at;
                }
            }
        }
        return -1
    },

    //columnGroupName
    setActiveColumnsWidth (resizingSubscriptId,iCol,width){
        var state = this;
        var model = state.model;
        var script = model.Script[model.loadedScriptId];
        var subscript = script.subscripts[resizingSubscriptId];
        var columns = subscript.columns?subscript.columns.slice(0):[];
        subscript.columns = columns;
        columns[iCol] = $.extend(true,{},columns[iCol]);
        columns[iCol].width = width;
    },

    deleteBlock : function (scriptId,subscriptId,at,number,dirty){

        if (at<0){
            throw ("Can not delete blocks before position 0 ");
        } else if (number) {
            var deletions = [];
            var subscript = this.model.Script[scriptId].subscripts[subscriptId];
            var orderedBlockIds = subscript.orderedIds.slice(0);
            subscript.orderedIds = orderedBlockIds;

            var count=number;
            while (count){
                var deleteAt = at+count-1;
                deletions.push(orderedBlockIds[deleteAt]);
                delete this.model.Block[makeUniversalBlockKey(scriptId,orderedBlockIds[deleteAt])];
                orderedBlockIds.splice(deleteAt,1);
                deleteFromPages(subscript,deleteAt);
                checkBlockIdCaches(subscript);
                count--;
            }

            if (dirty){
                dirty.add(scriptId,{
                    deletions:deletions,
                })
            }
        }
    },

    insertBlock : function ( scriptId , subscriptId , at , blocks , dirty ) {
        
        var state = this;

        if (!isArray(blocks)){
            blocks = [blocks];
        }
        var subscript = this.model.Script[scriptId].subscripts[subscriptId];
        subscript.orderedIds = subscript.orderedIds.slice(0);

        const maxOrderStep = 100000;
        const maxValue = 4294967295;
        const reorderTriggerGap = 100;
        const orderTopMargin = maxValue - maxOrderStep;
        const margin = maxOrderStep;

        var orderLowLimit = maxOrderStep;
        var orderHighLimit = maxValue - maxOrderStep;

        if (at){
            var blockBefore = this.getBlock(scriptId,subscriptId,at-1);
            orderLowLimit = blockBefore.ordering;
        }

        if (at < subscript.orderedIds.length){
            var blockAt = this.getBlock(scriptId,subscriptId,at);
            orderHighLimit = blockAt.ordering;
        }
        
        var orderGap = orderHighLimit - orderLowLimit;
        var orderStep = Math.round(Math.min(orderGap/(blocks.length+1),maxOrderStep));
        var needsReorder = orderStep < reorderTriggerGap;

        var scriptIsDirty = false;
        var creations= [];

        subscript.orderedIds = subscript.orderedIds.slice(0);

        if (!subscript.pages || !subscript.pages[0]){
            subscript.pages=[[]];
        }

        var ordering = Math.round(orderLowLimit + orderStep);

        $.each(blocks,(b,block)=>{

            if (!block.type){
                throw ("InsertBlock : A new block must have a type.");
            }

            block.text =  block.text?block.text:"";
            block.scriptId = scriptId;
            block.subscriptId = subscriptId;
            block.ordering = ordering;
            block.meta = block.meta ? block.meta : {}
            block.info = {};
            block.reference =  block.reference?block.reference:0;

            if (!block.id){
                block.id = state.getNextBlockId(scriptId); 
                scriptIsDirty = {nbid:true};
            }
            subscript.orderedIds.splice(at,0,block.id);
            insertIntoPages(subscript,block.id,at);
            checkBlockIdCaches(subscript); 

            state.model.Block[makeUniversalBlockKey(scriptId,block.id)] = block;
            
            creations.push(blockToBlockData(block));

            at++; // insert into the next location
            ordering += orderStep;
        })

        if (needsReorder){

            var orderStep = Math.round(Math.min((orderTopMargin-maxOrderStep)/(blocks.length+1),maxOrderStep));
            var ordering = maxOrderStep+1;
            $.each(subscript.orderedIds,(i,blockId)=>{
                state.model.Block[makeUniversalBlockKey(scriptId,blockId)].ordering = Math.round(ordering);
                ordering += orderStep
            })
        }

        if (dirty){
            var changes = {
                creations:creations,
            };
            if (scriptIsDirty){

                changes.scriptChange = {
                    bits : scriptIsDirty,
                    script : state.model.Script[scriptId]
                }
                
            }
            if (needsReorder){
                changes.reorderedSubscriptIds = [subscriptId];
            }
            dirty.add(scriptId,changes);
        }

    },



    getSubscriptOrderedBlockIds : function (scriptId,subscriptId){
        var blockIdList = access (this.model,['Script',scriptId,'subscripts',subscriptId,'orderedIds']);
        return (blockIdList ? blockIdList : [])
    },

    getBlockPosition : function (scriptId,subscriptId,blockId){
        var blockIdList = this.getSubscriptOrderedBlockIds(scriptId,subscriptId);
        if ( blockIdList ) {
            for (var i = 0;i<blockIdList.length;i++){
                if (blockIdList[i]==blockId){
                    return i;
                }
            }
        }
        return -1;
    },
    getBlock : function (scriptId,subscriptId,atPosition){
        var blockIdList = this.getSubscriptOrderedBlockIds(scriptId,subscriptId);
        
        if (blockIdList.length && atPosition<blockIdList.length){
            var blockId = atPosition>=0 ? blockIdList[atPosition] : blockIdList[blockIdList.length-1]
            var blockUid = makeUniversalBlockKey(scriptId,blockId);
            return this.model.Block[blockUid];
        }
        
        return null;
    },
    getBlockIdsAtPosition : function(scriptId,subscriptId,atPosition,number){
        var blockIdList = this.getSubscriptOrderedBlockIds(scriptId,subscriptId);
        if (atPosition<blockIdList.length-1){
            number = Math.min(number,blockIdList.length-atPosition);
            return  blockIdList.slice(atPosition,atPosition+number);
        } else {
            return [];
        }
    },
    getBlocksFromPosition : function (scriptId,subscriptId,atPosition,number){
        var idList = this.getBlockIdsAtPosition(scriptId,subscriptId,atPosition,number);
        return idList.map(blockId=>this.model.Block[makeUniversalBlockKey(scriptId,blockId)]);
    },

    getUnsortedSubscriptBlocks : function (scriptId,subscriptId){
        var blocks = [];
        $.each(this.model.Block,(uid,block)=>{
            if (block.scriptId == scriptId && block.subscriptId == subscriptId){
                blocks.push(block);
            }
        });
        return blocks;
    },

    dealWithSubscriptInvalidations : function(scriptId,subscriptId,invalidations){

        if (invalidations.navTreeInvalid){
            this.remakeNavTree(scriptId,subscriptId);
        }

        if (invalidations.range){
            this.selectionTrigger = invalidations.range;
        }

    },

    getNextBlockId : function(scriptId){
        var script = this.model.Script[scriptId];
        return script.nextBlockId++;
    },


    initializeSubscriptionBlockIdList : function(scriptId,subscriptId){
        var script = this.model.Script[scriptId];
        var subscript = script.subscripts[subscriptId]
        
        var orderingBlocks = [];
        $.each(this.model.Block,(blockUid,block)=>{
            if (block.subscriptId == subscriptId){
                orderingBlocks.push(block);
            }
        })
        orderingBlocks.sort((a,b)=>a.ordering-b.ordering);
        subscript.orderedIds= $.map(orderingBlocks,block=>block.id);
        
        // console.log ("redoing pages for subscript : "+ subscriptId);

        redoSubscriptPages(subscript);
    },

    remakeNavTree : function ( scriptId , subscriptId ) {
        var script = this.model.Script[scriptId];
        if(script){
            var subscript = script.subscripts[subscriptId];
            var subscriptTypeInfo = documentTypes[subscript.type];
            if (subscript) {   
                var unitList= []; 
                var unitStack = [{
                    level : 0,
                    headBlockUid : null, // script
                    subUnits : [],
                    parent : null,
                    isOpen : true , // just in case
                }];
                var currentUnit = unitStack[0];                
                $.each(subscript.orderedIds,(i,blockId)=>{
                    var block = this.model.Block[makeUniversalBlockKey(scriptId,blockId)];
                    var blockLevel = getBlockLevel(subscriptTypeInfo.levels,block.type);
                    if (blockLevel){
                        var currentLevel = currentUnit.level;
                        if (blockLevel <= currentLevel){
                            while (blockLevel <=  currentLevel){
                                currentUnit = currentUnit.parent;
                                currentLevel = currentUnit.level;
                            }
                        } 
                        var newUnit = {
                            level : blockLevel,
                            headBlockUid : makeUniversalBlockKey(scriptId,blockId), 
                            subUnits : [],
                            parent : currentUnit,
                            debugText : block.text,
                            isOpen : true,
                        };
                        currentUnit.subUnits.push(newUnit)
                        currentUnit = newUnit;
                        unitList.push(newUnit);
                    }
                });
                subscript.navTree = unitStack[0].subUnits;
                subscript.navList = unitList
            }
        } 
    },

});

export var characters = [];
export function remakeLineSizes ( scriptId , subscriptId ) {
    const model = modelStore.state.model;
    const script = model.Script[scriptId];
    const characterNames = {};
    characters = [];
    if(script){
        var subscript = script.subscripts[subscriptId];
        var subscriptTypeInfo = documentTypes[subscript.type];
        if (subscript) {   
            var unitList= []; 
            var unitStack = [{
                level : 0,
                headBlock : null, 
                subUnits : [],
                parent : null,
                block : { info:{size:0,page:0,characters:{},}},
            }];
            var currentUnit = unitStack[0];                
            $.each(subscript.orderedIds,(i,blockId)=>{
                var block = model.Block[makeUniversalBlockKey(scriptId,blockId)];
                
                var blockLevel = getBlockLevel(subscriptTypeInfo.levels,block.type);
                blockLevel = blockLevel?blockLevel:4; // leaf

                var currentLevel = currentUnit.level;
                if (blockLevel <= currentLevel){
                    while (blockLevel <=  currentLevel){
                        currentUnit = currentUnit.parent;
                        currentLevel = currentUnit.level;
                    }
                }
                block.info={size:0,page:0,characters:{}}
                var newUnit = {
                    level : blockLevel,
                    headBlockUid : makeUniversalBlockKey(scriptId,blockId), 
                    subUnits : [],
                    parent : currentUnit,
                    block : block,
                };
                currentUnit.subUnits.push(newUnit)
                currentUnit = newUnit;

                if ( block.type == "character" ) {
                    var name = block.text.toUpperCase();
                    var iBracket = name.indexOf('(');
                    if (iBracket>0){
                        name = name.substring(0,iBracket)
                    }
                    name = name.trim();
                    if (!characterNames[name]){
                        characterNames[name]=true;
                        characters.push(name);
                    }
                    var unit = currentUnit;
                    while (unit) {
                        if (unit.block){
                            unit.block.info.characters[name]=true;
                        }
                        unit = unit.parent;
                    }
                }

            });

            makeLineSizes(unitStack[0]);

            var atLine = 0;
            $.each(subscript.orderedIds,(i,blockId)=>{
                var block = model.Block[makeUniversalBlockKey(scriptId,blockId)];
                block.info.page = atLine;
                atLine += block.localLineSize;
            })

        }
    }

    function makeLineSizes(unit){
        unit.block.localLineSize = getBlockLineSize(unit.block);
        unit.block.info.size = unit.block.localLineSize;
        for ( var u=0 ; u < unit.subUnits.length ; u++ ) {
            var uuu = unit.subUnits[u];
            unit.block.info.size += makeLineSizes(uuu);
        }
        return unit.block.info.size;
    }
}

function getBlockLevel(levels,blockType){
    const blockLevel = levels[blockType];
    return blockLevel?blockLevel:0;
}

export function getSubscriptTrail(state,scriptId,subscriptId){
    
    state = state?state:modelStore.state;
    var model = state.model;
    var script,subscript,orderedIds;
    if (model.Script){
        script = model.Script[scriptId];
    }
    if (script){
        subscript = script.subscripts[subscriptId];
    }
    if (subscript){
        orderedIds = subscript.orderedIds;
    }
    return {
        model,
        script,
        subscript,
        orderedIds,
    }
}


function getBlockLineSize(block){
    switch (block.type){
        case 'character': {
            return 2
        } break;
        case 'dialog': {
            return Math.ceil(block.text.length/34)+1
        } break;
        case 'scene': {
            return 3
        } break;
        case 'shot': {
            return 2
        } break;
        case 'section': {
            return 0
        } break;
        case 'sequence': {
            return 0
        } break;
        case 'note': {
            return 0
        } break;
        case 'action': {
            return Math.ceil(block.text.length/62)+1
        } break;
        case 'transition': {
            return 2
        } break;
        case 'parenthetical': {
            return Math.ceil(block.text.length/24)
        } break;
    }
    return 1;
}

// function updateBlockLineSizeWithConcatenation(state,scriptId,subscriptId,blockAt,lineSizeChange){
    
//     const model = state.model;
//     const script = model.Script[scriptId];
//     const subscript = script.subscripts(subscriptId);
//     const blockId = subscript.orderedIds[blockAt];
//     var block = script.Block[makeUniversalBlockKey(scriptId,blockId)];

//     while (block){

//         var block = script.Block(makeUniversalBlockKey(scriptId,block.levelParentBlockId));
//         if (block){
//             block.lineSize += lineSizeChange;
//         }
//         subscript.lineSize += lineSizeChange;
//     }

// }

